import axiosInstance from '../initializers/axios';

export const toAbsoluteApiUrl = (url?: string | null) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:') || url.startsWith('data:')) return url;

  const path = url.startsWith('/') ? url : `/${url}`;
  const envBase = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (envBase) {
    if (envBase.endsWith('/api') && path.startsWith('/api/')) return `${envBase}${path.slice(4)}`;
    return `${envBase}${path}`;
  }

  const axiosBase = (axiosInstance.defaults.baseURL || '').trim().replace(/\/+$/, '');
  if (axiosBase) {
    if (axiosBase.endsWith('/api') && path.startsWith('/api/')) return `${axiosBase}${path.slice(4)}`;
    return `${axiosBase}${path}`;
  }

  return path;
};

export const buildEntityFileUrl = (entityId?: number | null, entityType?: number | null) => {
  if (!entityId || !entityType) return '';
  return toAbsoluteApiUrl(`/api/upload/download?entityId=${entityId}&entityType=${entityType}`);
};

export default buildEntityFileUrl;
